import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { Card, TextInput, PasswordInput, Button, ErrorMessage } from '../components/ui'

export default function LoginPage() {
  const navigate = useNavigate()
  const { login, isAuthenticated } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  // Redirect if already authenticated
  if (isAuthenticated) {
    navigate('/', { replace: true })
    return null
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      const result = await login(email, password)
      if (result.success) {
        navigate('/', { replace: true })
      } else {
        setError(result.error || 'Login failed')
      }
    } catch (err) {
      setError(err.message || 'Login failed')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-dial-black flex flex-col items-center justify-center px-4 py-8 safe-area-inset-top safe-area-inset-bottom">
      {/* Logo */}
      <div className="mb-8 text-center">
        <div className="w-20 h-20 bg-white dark:bg-dial-surface border border-gray-200 dark:border-dial-border rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg dark:shadow-lume">
          <span className="text-4xl font-bold text-primary-600 dark:text-lume-teal font-display lume-glow">F</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-indices-bright font-display">Forge</h1>
        <p className="text-gray-500 dark:text-indices-muted mt-1">Trainer Portal</p>
      </div>

      {/* Login Form */}
      <Card className="w-full max-w-sm" padding="lg">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-indices-bright mb-6 text-center font-display">Sign In</h2>

        <ErrorMessage error={error} className="mb-4" />

        <form onSubmit={handleSubmit} className="space-y-4">
          <TextInput
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            autoComplete="email"
          />

          <PasswordInput
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            autoComplete="current-password"
          />

          <Button
            type="submit"
            fullWidth
            loading={isLoading}
          >
            Sign In
          </Button>
        </form>
      </Card>

      <p className="mt-8 text-gray-500 dark:text-indices-muted text-sm">
        AI-Powered Personal Training Management
      </p>
    </div>
  )
}
